// UTC, as the ledger's months and the runbook's queries are.
export const formatUtc = (iso: string) => `${iso.slice(0, 10)} ${iso.slice(11, 16)}`
